import React from "react";
import { Accordion, Flex } from "@telia/teddy";
import _isEmpty from "lodash/isEmpty";
import { RDFaq } from "../../../../../../models/rdStatic";
import "./FAQ.less";
import { trackUIClickEvent } from "../../../../google-analytics/googleAnalyticsEventHelper";

interface FAQProps {
    items?: RDFaq[];
    title?: string;
    trackingContext?: { prefix: string; url: string };
}

export const FAQ: React.FC<FAQProps> = ({ title = "Vanlige spørsmål", items, trackingContext }) => {
    if (!items || _isEmpty(items)) {
        return null;
    }
    return (
        <Flex id="faq" direction="column" width="100%" align="center" justify="start">
            <Accordion type="multiple" className="faq__accordion">
                <Accordion.Title as="h2" variant="title-300">
                    {title}
                </Accordion.Title>
                {items.map((item) => (
                    <Accordion.Item key={item.title} value={item.title}>
                        <Accordion.Header>
                            <Accordion.Trigger
                                onClick={() => {
                                    if (trackingContext) {
                                        trackUIClickEvent({
                                            action: "click",
                                            context: `${trackingContext.prefix}_faq`,
                                            text: item.title,
                                            type: `${trackingContext.prefix}_accordion`,
                                            url: trackingContext.url,
                                        });
                                    }
                                }}
                            >
                                {item.title}
                            </Accordion.Trigger>
                        </Accordion.Header>
                        <Accordion.Content>
                            <div dangerouslySetInnerHTML={{ __html: item.text }} />
                        </Accordion.Content>
                    </Accordion.Item>
                ))}
            </Accordion>
        </Flex>
    );
};

export default FAQ;
